(() => {
  const initYearbookBanner = (root) => {
    if (!root || root.dataset.yearbookReady === 'true') return;

    const opener = root.querySelector('[data-yearbook-video-open]');
    const modal = root.querySelector('[data-yearbook-video-modal]');
    const closer = root.querySelector('[data-yearbook-video-close]');
    const iframe = modal?.querySelector('iframe');

    root.dataset.yearbookReady = 'true';

    const trustSlider = root.querySelector('[data-yearbook-trust-slider]');
    const mountTrustSlider = () => {
      if (!trustSlider || trustSlider.classList.contains('is-initialized')) return;
      if (typeof window.Splide === 'undefined') {
        window.setTimeout(mountTrustSlider, 80);
        return;
      }
      const trustSplide = new window.Splide(trustSlider, {
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: true,
        drag: true,
        rewind: true,
        mediaQuery: 'min',
        breakpoints: {
          750: {
            destroy: true
          }
        }
      });
      trustSplide.mount();
      root.yearbookTrustSplide = trustSplide;
    };
    mountTrustSlider();

    if (!opener || !modal || !iframe) return;

    const closeVideo = () => {
      iframe.removeAttribute('src');
      if (modal.open) modal.close();
    };

    opener.addEventListener('click', () => {
      iframe.src = iframe.dataset.src;
      modal.showModal();
    });

    closer?.addEventListener('click', closeVideo);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeVideo();
    });
    modal.addEventListener('cancel', () => iframe.removeAttribute('src'));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-yearbook-banner]').forEach(initYearbookBanner);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
